export default "__VITE_PUBLIC_ASSET__5d60f48f__"